import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { tabs } from 'src/app/dummy/tabs';
import { DataService } from 'src/app/services/data.service';
import { AddRoomComponent } from './add-room/add-room.component';
import { APPS } from 'src/app/dummy/app';
import { LazyData } from 'src/app/stores/administrator/lazyData.store';

@Component({
  selector: 'app-room',
  templateUrl: './room.component.html',
  styleUrls: ['./room.component.scss']
})
export class RoomComponent implements OnInit {
  tabs = tabs.CAMPUS

  constructor(
    private router: Router,
    public store: LazyData,
    public ds: DataService,
    public dialog: MatDialog) { }

  create(event?) {
    const dialogRef = this.dialog.open(AddRoomComponent, {
      data: null,
      panelClass: 'register-test-overlay-panel',
      width: '30vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }

  ngOnInit() {
    this.store.fetchData(this.ds.roomsRef(ref => ref
      .orderBy('page_key')
      .limit(APPS.SIZE)))
  }

  onScroll() {
    const { lastVisible } = this.store;
    if (!lastVisible) return;
    this.store.fetchMore(this.ds.subjectRef(ref => ref
      .orderBy('page_key')
      .startAfter(lastVisible.page_key)
      .limit(APPS.SIZE)))
  }

  ngOnDestroy() {
    this.store.dispost();
  }
}
